import { t } from "i18next";
import PropTypes from "prop-types";

function NoDataTables({ message = "Nenhum dado encontrado", addItem }) {
  return (
    <div
      className="alert alert-warning mt-4 d-flex align-items-center w-100"
      role="alert"
    >
      {t(message)}
      {t("full_stop")}
      {addItem && (
        <div>
          <button
            type="button"
            className="btn btn-link p-0 ms-2 "
            onClick={addItem}
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            {t("add_new_item")}
          </button>
        </div>
      )}
    </div>
  );
}

NoDataTables.propTypes = {
  message: PropTypes.string,
  addItem: PropTypes.func,
};

export default NoDataTables;
